'use client';
import { use } from 'react';

import EventComponent from '../../../../components/Event/EventComponent';
import { useFriendlyViewPort } from '../../../../hooks/useFriendlyViewPort';
import PageHeader from '../../../../components/PageHeader/PageHeaderOld';
import { useViewportSizeTracking } from '../../../../hooks/useViewportSizeTracking';
import { notFound } from 'next/navigation';
import FestComponent from '../../../../components/Event/FestComponent';
import { getAllActiveEvents } from '../../../../utils/getAllActiveEvents';
import eventsVal from './page.val';
import { useVal, useValRoute } from '../../../../val/val.client';
import eventSeriesVal from '../../../../settings/eventSeries.val';

const Event = (props: { params: Promise<{ slug: string }> }) => {
  const params = use(props.params);
  const { slug } = params;
  const event = useValRoute(eventsVal, params);
  const eventSeries = useVal(eventSeriesVal);
  const eventsBySlug = getAllActiveEvents(useVal(eventsVal), eventSeries);
  useFriendlyViewPort();
  useViewportSizeTracking();

  const events = Object.entries(eventsBySlug).map(([slug, event]) => ({
    slug,
    ...event,
  }));

  if (!event) {
    notFound();
  }
  const eventsSortedByDate = events.sort((a, b) => {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
  });
  const eventsSortedByDateInSeries = eventsSortedByDate.filter(
    (e) => e.type === event.type
  );
  const numberInSeries =
    eventsSortedByDateInSeries.findIndex((e) => e.slug.endsWith(`/${slug}`)) +
    1; // 1-indexed

  return (
    <>
      <PageHeader
        title={event.title}
        imgSrc={event.eventImage}
        alt={event.title}
        eventSeries={
          event.type !== 'party'
            ? `${eventSeries[event.type].title}#${numberInSeries
                .toString()
                .padStart(3, '0')}`
            : undefined
        }
        layout="child:max-w-[75%] max-w-[1260px] pb-[0px] tablet:pb-[0px] laptop:pb-[0px] desktop:pb-[0px] mb-[20px] mx-[20px] tablet:mx-[20px] laptop:mx-[50px] desktop:mx-[150px]"
        extraPaddingRight
      />

      <div
        id={slug}
        className="items-center justify-center w-full no-transition-on-load transition-bg-1s "
      >
        <div>
          {event.type === 'party' ? (
            <FestComponent {...event} />
          ) : (
            <EventComponent
              {...event}
              slug={slug}
              events={events}
              numberInSeries={numberInSeries}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Event;
